import { render } from "./TasksUnfinishedListView.vue?vue&type=template&id=20ccfea2"
import script from "./TasksUnfinishedListView.vue?vue&type=script&lang=js"
export * from "./TasksUnfinishedListView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__